import React from "react";
import { Button } from "react-bulma-components";

function PackageButton(props){
    return(
        <>
        <Button
        id={props.package}
        name={props.package}
        value={props.package}
        status = {props.package === props.currentTier ? "active" : undefined}
        onClick = {props.onclick}
        color={"primary"}
        //fullwidth={props.package === "Complete" || props.package === "Local Plus" || props.package === "Complete Lite" ? true: false}
        size={props.package === "Complete" || props.package === "Local Plus" || props.package == "Complete Lite" || props.package == "Advanced" || props.package == "Ultra" ? "large": "undefined"}
        >{props.package}</Button>
        </>
    )
}

export default PackageButton